import { render, staticRenderFns } from "./AppleStoreText.vue?vue&type=template&id=74508c9a&"
import script from "./AppleStoreText.vue?vue&type=script&lang=js&"
export * from "./AppleStoreText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports